export  const BASE_URL='http://garthbeetle.pythonanywhere.com/api/'



// WEBPACK FOOTER //
// ./src/constants.js